webpackJsonp([16281271987338],{

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(21);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(16);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(14);
	
	__webpack_require__(13);
	
	var _reactLinkedinInsight = __webpack_require__(19);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/Sarika-Saxena-img-1.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/sunilgoyal.jpg";
	var icon3 = "https://winpeforum.com/assets/elements/yourstory-press-nupur-garg.jpg";
	
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/sheshines/17feb2026/1.png";
	var I2 = "https://www.winpeforum.com/assets/sheshines/17feb2026/2.png";
	var I3 = "https://www.winpeforum.com/assets/sheshines/17feb2026/3.png";
	var I4 = "https://www.winpeforum.com/assets/sheshines/17feb2026/4.png";
	var I5 = "https://www.winpeforum.com/assets/sheshines/17feb2026/5.png";
	var I6 = "https://www.winpeforum.com/assets/sheshines/17feb2026/6.png";
	var I7 = "https://www.winpeforum.com/assets/sheshines/17feb2026/7.png";
	var I8 = "https://www.winpeforum.com/assets/sheshines/17feb2026/8.png";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/1.png";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/2.png";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/3.png";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/4.png";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/5.png";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/6.png";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/7.png";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/8.png";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\n       Sarika Saxena is the Managing Partner at IAN Alpha Fund, an offshoot of the Indian Angel\nNetwork, with over 25 years of experience across Indian, UK, and US markets. She has spent\nover 20 years in the start-up, PE, and VC space.<Br/><Br/>\nHer expertise includes M&amp;A (heading M&amp;A at Mphasis), cross-border transactions, debt &amp;\nequity, and fund raising, notably raising $42m for Value Based Housing Corporation. Sarika\nalso played a pivotal role in establishing the innovative NBFC, Nfin. She holds an MBA from\nthe London Business School.\n\n\n            </div>",
	      name: "Sarika Saxena",
	      post: "<div>Managing Partner<br/> Indian Angel Network\n\n \n     \n            </div>"
	    }, {
	      imgUrl: icon2,
	      desc: " Sunil K. Goyal co-founded YourNest, an early-stage venture fund, in 2011, and he now manages a US$ 100 million fund corpus across three funds. YourNest invests in Indian technology startups that create innovative products for global markets. Sunil believes in conscious capitalism\u2019 and relishes driving businesses with a high sense of purpose and vision. He had played a pivotal role in Dabur and Airtel before launching YourNest. Startups\ngain from his experiences in building businesses from the early stage to leading business transformation. He is a qualified CFA, Cost Accountant with a master\u2019s in business economics from the University of Delhi.\n",
	      name: "Sunil Goyal",
	      post: "<div>Managing Director & Fund Manager<br/> YourNest Venture Capital\n\n \n            </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. She is the founder of Winpe (https://winpeforum.com), an initiative to enhance gender diversity in the investing ecosystem.<br/><br/>\n    \n    \n    Nupur serves as Chairperson of the board of Kids Clinic India Limited and an independent director on the boards of companies including Edelweiss Real Assets Managers Limited, Kerala Infrastructure Fund Management Limited and SIDBI, the Indian development finance institution. She is an independent member of the investment committee at the Fund of Funds managed by the National Investment and Infrastructure Fund (NIIF), the quasi-sovereign wealth fund sponsored by the government of India, and an advisor to and a member of the investment committee for the Dutch Good Growth Fund (DGGF) investment funds mandate given by the Dutch government for investments in SMEs in frontier markets across 75 countries. She has served as an external expert on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for investing in the Indian start-up ecosystem. Nupur advises select fund managers on a confidential basis on matters related to institutionalization, best practices and governance. She also mentors female entrepreneurs across various platforms.\n    <br/><br/>\n    \n    Nupur is recognized as a thought and industry leader with a long list of recognitions that include the\n    HerPower Award 2023, BW VC World Most Influential Women 2023 and 2022, Forbes W-Power list of\n    Self Made Women 2020, India\u2019s top 10 Women Leaders in Finance (AIWMI 2019), Vedica Women\u2019s\n    Alliance\u2019s Women Leader in D&I 2022, Women Empowerment Entrepreneur Award 2019-20 and the\n    Business Excellence and Innovative Best Practices - Academia Award 2019.\n    <br/><br/>\n    \n    Prior to starting her entrepreneurial journey, Nupur led the private equity and venture capital funds\n    business in the region for IFC and is widely credited with establishing IFC\u2019s brand and credibility as one\n    of the most respected institutional investors in this space. Under her stewardship, the portfolio doubled in\n    size and returns, moving from a negative IRR to delivering gains for the first time in its history.\n    <br/><br/>\n    \n    Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from\n    Harvard Business School.\n    \n    <br/><br/>\n    Nupur loves to spend time with her mother, husband and 8-year-old son, travel to new places, read and\n    do 1500-piece puzzles.</div> ",
	      name: "Nupur Garg",
	      post: "<div>Founder<br/> Winpe\n\n\n \n            </div>"
	    }];
	
	    _this.Speaker2 = [];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I2, ImgSrc1: II2 }, { id: 22, ImgSrc: I3, ImgSrc1: II3 }, { id: 19, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 34, ImgSrc: I6, ImgSrc1: II6 }, { id: 23, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "sheshines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Winpe sheshines | February 17, 2026"
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " sheshines Delhi: When Things Don\u2019t Go to Plan \u2014 ",
	                  _react2.default.createElement("br", null),
	                  "Pivots, Shutdowns, Down-Rounds & Difficult Conversations"
	                ),
	                " ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "February 17, 2026 (5:00 - 8:00 PM IST)"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Jaypee Vasant Continental, New Delhi"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "On 17th February 2026, sheshines Delhi gathered founders and investors at Jaypee Vasant Continental, New Delhi, for a deeply honest conversation on the less-discussed side of entrepreneurship and investing - the moments of uncertainty, recalibration, and hard choices. The session moved beyond success stories to focus on what happens when growth stalls, assumptions break, and leaders are forced to rethink their path forward.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Designed as a forum for candid learning and peer exchange, sheshines by Winpe creates trusted spaces where women founders and investors share real experiences, strengthen networks, and collectively build resilience within the investing ecosystem.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Event Highlights"
	              ),
	              "          ",
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              "What set this session apart was its scenario-led format, which placed participants in realistic, high-pressure situations\u2014from negotiating down rounds to deciding when to pivot or shut down. These case-based discussions encouraged practical thinking and revealed how values, judgment, and communication styles surface most clearly during adversity.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Rather than offering prescriptive answers, the speakers focused on how leaders process setbacks, balance competing stakeholder interests, and maintain credibility in turbulent phases. Founders in the room reflected on navigating personal doubt and external pressure, while investors shared how they evaluate leadership maturity during difficult cycles.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The dialogue emphasized that challenging phases are not merely operational hurdles, but defining moments that shape long-term reputation, trust, and leadership legacy.",
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                    "Speakers & Moderator"
	                  ),
	                  "          ",
	                  _react2.default.createElement("div", { "class": "r_btm" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Our_Speakers container" },
	                    _react2.default.createElement(
	                      "center",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Speakers_img", style: { width: '100%', margin: '0' } },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          this.Speaker1.map(function (item, i) {
	                            if (i <= 10) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "main_speaker_card col-md-4 col-sm-12 col-lg-4",
	                                  key: i
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "Scardd" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "s_img",
	                                      onClick: function onClick() {
	                                        return _this3.togglePopUp(item);
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "center",
	                                      null,
	                                      "  ",
	                                      _react2.default.createElement("img", {
	                                        src: item.imgUrl,
	                                        alt: item.name,
	                                        className: "img-responsive",
	                                        style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement("br", null),
	                                  "    ",
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_name",
	                                    dangerouslySetInnerHTML: { __html: item.name }
	                                  }),
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_post",
	                                    dangerouslySetInnerHTML: { __html: item.post }
	                                  })
	                                )
	                              );
	                            } else return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Key Takeaways "
	              ),
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Resilient Leadership Over Reactive Decisions"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Strong leaders respond to adversity with clarity and composure, using data and perspective rather than emotion to guide critical choices."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Adaptability and Coachability Matter"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Founders who remain open to feedback, adapt quickly, and build on insights - rather than defending ego - are better positioned to navigate downturns."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Emotional Maturity Is a Core Leadership Skill"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Handling uncertainty, disappointment, and pressure with emotional intelligence strengthens teams and investor relationships."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Capital Discipline and Transparency Are Non-Negotiable"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Investors emphasized the importance of responsible capital deployment, clear reporting, and honesty - especially in difficult phases."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Prepare for Dilution and Changing Outcomes"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Founders must be mentally and strategically prepared for dilution, pivots, and evolving roles as companies grow and restructure."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Separate Identity from Outcomes"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Personal self-worth should not be tied solely to venture success. Healthy detachment enables better decision-making and long-term resilience."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Exit with Dignity When Needed"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Knowing when and how to wind down responsibly is a sign of leadership. Preserving integrity, team welfare, and stakeholder trust matters deeply."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Trust Is Built in Adversity"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "The toughest moments often define relationships. Trust grows through honest communication, data-driven choices, and the courage to confront hard realities."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "A Session of Reflection and Strength"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The evening encouraged founders to confront difficult truths without losing optimism or integrity. Investors, in turn, shared the responsibilities they carry towards LPs, teams, and the broader ecosystem - highlighting the shared accountability that underpins sustainable entrepreneurship.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "The open exchange fostered empathy, mutual respect, and practical clarity, leaving participants better equipped to face uncertainty with confidence and composure.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "As with every sheshines edition, this session reinforced Winpe\u2019s commitment to building inclusive, supportive platforms where women entrepreneurs and investors can learn from real experiences, strengthen networks, and grow together within the PE\u2013VC ecosystem."
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Heading2.default, { title: "Gallery" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.CollegiumsImages.map(function (item, j) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-4 col-sm-6 col-xs-12", style: { padding: '8px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img_card" },
	                      _react2.default.createElement("img", { style: { width: '100%' }, src: item.ImgSrc, alt: "Winpe sheshines" }),
	                      _react2.default.createElement(
	                        "a",
	                        { href: item.ImgSrc1 },
	                        " ",
	                        _react2.default.createElement("i", { style: { color: 'white', position: 'absolute', left: '20px', top: '20px' }, "class": "fa fa-2x  fa-download " })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sheshines-17-feb-2026-index-js-c28d080b93f61665b35c.js